import { Component } from "@angular/core";

@Component({
    selector: "prompt-modal",
    template: `
        <div class="mod mod-modal" [class.is-open]="isVisible">
            <div class="mod-modal__dialog mod-modal__dialog--medium">
                <div class="mod-modal__content">
                    <span>{{ message }}</span>
                    <div class="zas-main-col">
                        <input
                            type="text"
                            name="value"
                            class="form-control"
                            [(ngModel)]="value"
                        />
                    </div>
                </div>
                <div class="mod-modal__footer">
                    <button class="zas-button" (click)="submit()">
                        Speichern
                    </button>
                    <button class="zas-button" (click)="close()">
                        Abbruch
                    </button>
                </div>
            </div>
        </div>
    `,
    styleUrls: ["./zurich-style.css", "./zurich.css", "./main.css"],
})
export class PromptModalComponent {
    static instance: PromptModalComponent;

    public static open(
        msg: string,
        onSubmit: SubmitFn,
        initialValue?: string,
    ): void {
        if (!PromptModalComponent.instance) {
            return;
        }
        PromptModalComponent.instance.open({ msg, onSubmit, initialValue });
    }

    isVisible = false;
    value: string;
    message = "";
    onSubmit: SubmitFn;
    promptQueue: Prompt[] = [];

    constructor() {
        PromptModalComponent.instance = this;
    }

    public open(prompt: Prompt): void {
        if (!this.isVisible) {
            this.isVisible = true;
            this.message = prompt.msg;
            this.onSubmit = prompt.onSubmit;
            this.value = prompt.initialValue;
        } else {
            this.promptQueue.unshift(prompt);
        }
    }

    public submit(): void {
        this.close();
        setTimeout(() => this.onSubmit(this.value));
    }

    public close(): void {
        this.isVisible = false;
        if (this.promptQueue.length) {
            this.open(this.promptQueue.pop());
        }
    }
}

type SubmitFn = (value: string) => void;
interface Prompt {
    msg: string;
    onSubmit: SubmitFn;
    initialValue?: string;
}
